document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tab-image-slider').forEach((section, index) => {
    const sliderEl = section.querySelector('.slider');
    const tabBox = section.querySelector('.tab-box');
    if (!sliderEl || !tabBox) return;

    const $slider = window.jQuery ? window.jQuery(sliderEl) : null;
    if (!$slider || !window.jQuery.fn?.slick) return;

    const tabButtons = Array.from(tabBox.querySelectorAll('button[data-index]'));

    const scrollTabIntoView = (btn) => {
      if (!btn) return;

      const applyScroll = () => {
        const maxScroll = Math.max(0, tabBox.scrollWidth - tabBox.clientWidth);
        if (maxScroll === 0) return;

        const boxRect = tabBox.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();
        const btnLeft = btnRect.left - boxRect.left + tabBox.scrollLeft;
        const centered = btnLeft - (tabBox.clientWidth - btnRect.width) / 2;
        const target = Math.max(0, Math.min(centered, maxScroll));

        if (Math.abs(tabBox.scrollLeft - target) < 1) return;

        // iOS Safari often ignores scrollTo({ behavior: 'smooth' }) on overflow-x boxes
        const prevBehavior = tabBox.style.scrollBehavior;
        tabBox.style.scrollBehavior = 'auto';
        tabBox.scrollLeft = target;
        tabBox.style.scrollBehavior = prevBehavior;
      };

      requestAnimationFrame(() => requestAnimationFrame(applyScroll));
    };

    const setActiveTab = (slideIndex) => {
      tabButtons.forEach((btn) => {
        const i = Number(btn.dataset.index);
        const isActive = i === slideIndex;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) scrollTabIntoView(btn);
      });
    };

    const initSlider = () => {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('refresh');
        return;
      }

      $slider.on('init', (_event, slick) => {
        setActiveTab(slick.currentSlide || 0);
      });

      $slider.on('beforeChange', (_event, _slick, _current, nextSlide) => {
        if (typeof nextSlide === 'number') setActiveTab(nextSlide);
      });

      $slider.slick({
        infinite: true,
        draggable: true,
        centerMode: true,
        centerPadding: '18.75%',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: false,
        prevArrow: `<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="tab-image-slider-prev-${index}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="tab-image-slider-prev-${index}">Prev Item</title><g data-name="Layer 2"><g data-name="Layer 1"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></svg><span hidden="hidden">Previous</span></button>`,
        nextArrow: `<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="tab-image-slider-next-${index}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="tab-image-slider-next-${index}">Next Item</title><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5"></polygon></g></svg><span hidden="hidden">Next</span></button>`,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false,
              centerPadding: '0',
              arrows: true,
              dots: false
            }
          },
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false,
              centerPadding: '0',
              arrows: false,
              dots: true
            }
          }
        ]
      });
    };

    // Tabs → slickGoTo (custom dots)
    tabBox.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-index]');
      if (!btn || !tabBox.contains(btn)) return;
      const targetIndex = Number(btn.dataset.index);
      if (Number.isNaN(targetIndex)) return;

      if (!$slider.hasClass('slick-initialized')) {
        initSlider();
      }
      $slider.slick('slickGoTo', targetIndex);
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              initSlider();
              observer.disconnect();
            }
          });
        },
        { threshold: 0.3 }
      );
      observer.observe(section);
    } else {
      initSlider();
    }
  });
});
